module.exports = __webpack_public_path__ + "static/media/htlp.79950ec5.svg";